<div class="kEntrySelector">
  <div class="kEntrySelectorTable" [class.kEntriesSelectorBucketOpened]="selectedEntries.length">
    <kEntriesList
      [showReload]="false"
      [columns]="columns"
      [defaultFilters]="defaultFilters"
      [enforcedFilters]="enforcedFilters"
      (onActionsSelected)="_onActionSelected($event)"
    >
    </kEntriesList>
  </div>
  <div class="kEntrySelectorBucket" *ngIf="selectedEntries.length">
    <div class="KEntrySelectorSelectedItemsWrapper">
      <div class="KEntrySelectorSelectedItem" *ngFor="let entry of selectedEntries">
        <div class="kThumbnailHolder">
          <img
            [src]="entry.thumbnailUrl"
            [alt]="entry.name"
            onError="this.onerror=null;this.style.display='none'"
            *ngIf="!(_kmcPermissions.FEATURE_DISABLE_KMC_LIST_THUMBNAILS | kNgIfPermitted)"
          />
          <div class="kIcons">
            <i
              class="kIconyoutube kThumbnailTypeIcon"
              *ngIf="entry.externalSourceType === _youtubeExternalSourceType"
            ></i>
            <i class="kIconquiz kThumbnailTypeIcon" *ngIf="entry.isQuizEntry"></i>
          </div>
        </div>
        <span [kTooltip]="entry.name">{{ entry.name }}</span>
        <i class="kIcontrash" (click)="_removeSelected(entry)"></i>
      </div>
    </div>
  </div>
</div>
